export const AppliedFilterDisplay = ({ label, value, onCloseClick, onTextClick, isResettable = false, isLabelOnly = false }) => {
    const labelText = isLabelOnly ? label : `${label}:`

    return (
        <div className="badge badge-primary d-flex align-items-center text-white p-0 applied-filter-display">
            <button type="button" onClick={() => {
                if (onTextClick) {
                    onTextClick(label)
                }
            }} className="btn btn-none btn-sm m-0 d-flex align-items-center px-2">
                <label className="text-white m-0 fs--1">{labelText}</label>
                {
                    !isLabelOnly &&
                    <>
                        &nbsp;
                        <p className="text-white fs--1 m-0 text-ellipsis">{value}</p>
                    </>
                }
            </button>
            <button onClick={() => onCloseClick(label)} type="button" title={ isResettable ? "Reset to default" : "Remove filter" } className="btn btn-none btn-sm m-0 p-0 py-2 px-2 border-left"><i className={ `fas ${ isResettable ? "fa-undo" : "fa-times" } text-white m-0 p-0` }></i></button>
        </div>
    )
}